import { render, staticRenderFns } from "./KnowPage.vue?vue&type=template&id=f835f6ac&scoped=true&"
import script from "./KnowPage.vue?vue&type=script&lang=js&"
export * from "./KnowPage.vue?vue&type=script&lang=js&"
import style0 from "./KnowPage.vue?vue&type=style&index=0&id=f835f6ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f835f6ac",
  null
  
)

export default component.exports